exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr>td[data-v-565ed7af]{width:35%;height:30px}.padding-2percent[data-v-565ed7af]{padding-top:2%}", ""]);

// exports
